var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location-details"},[_c('SideModalHeader',{attrs:{"title":_vm.title,"description":_vm.description}}),_c('LocationManager',{attrs:{"business":_vm.business,"address":_vm.location,"type":_vm.type}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }